import { TrackingActions, SET_TRACKING_BASE, TrackingBaseData } from './types';

export const setBaseTracking = (
  payload: TrackingBaseData,
): TrackingActions => ({
  type: SET_TRACKING_BASE,
  payload,
});
